import { lazy } from 'react';

// Client Offboarding (Part C2)
export const ClientOffboarding = lazy(() =>
  import('@/workflows/customer-offboarding/pages/ClientOffboarding').then((m) => ({ default: m.ClientOffboarding }))
);
